package org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.series.reset_range_loyalty_card


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class ResetRangeLoyaltyCardModel(
    @SerialName("data")
    val `data`: Data?,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)